import React, { useEffect } from 'react'
import { TableManage } from '../../shared/components/table/table-manage.component'
import { Supplier } from '../../shared/shared.models'
import { SortOrderEnum, SortUtils } from '../../shared/sort.utils'
import { ColumnProps } from '../../shared/components/table/table.component'
import { HeaderEnumSupplier } from '../../shared/components/table/table-headers.component'
import { RoutesEnum } from '../../routes.constants'
import { useNavigate } from 'react-router-dom'
import { Column } from '../../shared/shared.styled'
import Loader from 'react-spinners/DotLoader'
import styled from 'styled-components'
import { Colors, Typography } from '../../configs/styled.config'
interface CompanySuppliersProps {
    suppliers: Supplier[] | undefined
    companyId: string
    isLoading: boolean
}

const CompanySuppliers = ({
    suppliers,
    companyId,
    isLoading,
}: CompanySuppliersProps) => {
    const navigate = useNavigate()
    const [visibleSuppliers, setVisibleSuppliers] = React.useState(
        suppliers ? suppliers : []
    )

    const editSuppliers = (supplier: Supplier) => {
        navigate(
            RoutesEnum.GET_SUPPLIER.replace(':supplierId', supplier.uuid ?? '')
        )
    }
    const onHeaderClick = (header: string, order: SortOrderEnum) => {
        const sortedSuppliers = SortUtils.sortSuppliers(
            visibleSuppliers,
            header,
            order
        )
        setVisibleSuppliers(sortedSuppliers)
    }

    useEffect(() => {
        if (suppliers) {
            setVisibleSuppliers(suppliers)
        }
    }, [suppliers])

    const getColumns = (): ColumnProps[] => {
        return [
            {
                key: HeaderEnumSupplier.NAME,
                ratio: 4 / 12,
                label: 'Nome',
                renderFunction: (supplier) => supplier.name,
                onClick: onHeaderClick,
            },
            {
                key: HeaderEnumSupplier.FREQUENT,
                label: 'É frequente',
                ratio: 2 / 12,
                renderFunction: (supplier) =>
                    supplier.isFrequent ? 'Sim' : 'Não',
            },
            {
                key: HeaderEnumSupplier.NUMBER_VEHICLES,
                label: 'Nº de veículos fornecidos',
                ratio: 2 / 12,
                renderFunction: (supplier) => supplier.numberVehicles,
                onClick: onHeaderClick,
            },
        ]
    }

    return isLoading ? (
        <Column
            style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Loader color={Colors['gold-pmauto']} />
            <LoadingText>A processar os cálculos necessários...</LoadingText>
        </Column>
    ) : (
        <TableManage
            companyId={companyId}
            isLoadingData={false}
            values={visibleSuppliers}
            onRowClick={editSuppliers}
            columns={getColumns()}
            type="fornecedores"
        />
    )
}

export default CompanySuppliers

const LoadingText = styled('span')`
    margin-top: 24px;
    ${Typography['Body_Text_#1_Regular_Center']}
`
